import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { LunchBenefitActivationDialogExtension } from './extension/lunch-benefit-activation-dialog.extension';
import { LunchBenefitColumnsExtension } from './extension/lunch-benefit-columns.extension';
import { LunchBenefitInfoTextExtension } from './extension/lunch-benefit-info-text.extension';
import { LunchBenefitMetadataExtension } from './extension/lunch-benefit-metadata.extension';
import { LunchBenefitNavigationExtension } from './extension/lunch-benefit-navigation.extension';

export { default as lunchIcon } from './lunch.svg';
EXTENSIONS.registerExtension(
  new ExtensionBuilder('lunch')
    .add(BenefitMetadataExtensionInterface, new LunchBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new LunchBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new LunchBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new LunchBenefitActivationDialogExtension())
    .add(BenefitInfoTextExtensionInterface, new LunchBenefitInfoTextExtension())
    .build(),
);
